<!--
  목적 : 라벨 타이틀과 값 표시 컴포넌트
  작성자 : ldy
  Detail :
  *
  examples:
  *
  -->
<template>
  <div class="fix-height">
      <div class="row items-center all-pointer-events">
        <b>
          <i class="pe-7s-comment lblIcon"></i>
          <font class="lbltitle">{{convertTitle}}</font>
        </b>
      </div>
      <div v-if="view==='text'" class="lblvalue" :style="setStyle" v-html="convertValue"></div>
      <div v-else class="lblvalue" :style="setStyle">
        <slot name="contents"></slot>
      </div>
  </div>
</template>

<script>
import mixinCommon from './js/mixin-common'
export default {
  name: 'c-label-text',
  mixins: [mixinCommon],
  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: [String, Number],
      default: '',
    },
    row: {
      type: Number,
      default: 0,
    },
    view: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    setStyle() {
      let returnStyle = '';
      let height = this.row > 0 ? String(22 * this.row) + 'px' : 'auto';
      returnStyle = 'max-height: ' + height + ';min-height: ' + (height === 'auto' ? '27.1007px' : height) + ';';
      let fontColor = !(this.row > 0) ? 'color: #2196F3;' : '';
      returnStyle += fontColor;
      return returnStyle
    },
    convertValue() {
      let vValue = this.value
      if (this.value === null) {
        vValue = 'N/A';
      }
      if (vValue) {
        vValue = String(vValue).replace(/\n/g, '<br/>');
      }
      return vValue;
    }
  },
  watch: {
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    this.init();
  },
  mounted() {},
  beforeDestory() {
    this.init();
  },
  /** methods **/
  methods: {
    init() {
      // TODO : 여기에 초기 설정용 함수를 호출하거나 로직을 입력하세요.
    },
  },
};
</script>
<style lang="scss">
.lblvalue {
  padding: 2px 8px !important;
  height: 100% !important;
  word-wrap: break-word;
  border-bottom: 1px solid rgba(0,0,0,0.3);
  overflow-y: auto;
  font-size: 0.95em;
}
.lbltitle {
  font-size: 0.8rem !important;
}
.lblIcon {
  font-size: 0.7rem !important;
  margin-right: 4px;
  font-weight: 600;
}
</style>
